import {
     Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input, EventEmitter, Output
    } from '@angular/core';
import { consumeEvent, UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-sidebar-header-user-profile',
    templateUrl: './sidebar-header-user-profile.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarHeaderUserProfileComponent {
    @Input() impersonateLabel = ''; // impersonating
    @Input() welcomeLabel = '';     // Welcome
    @Input() isOnline = true;

    @Output() toggle: EventEmitter<any> = new EventEmitter();

    public toggleProfile = false;

    constructor(
        public asServie: UxAppShellService,
    ) {
    }

    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    getCssClasses() {
        return [
            `eui-app-sidebar-header-user-profile`,
        ].join(' ').trim();
    }

    onProfileClick(event: any) {
        this.toggleProfile = !this.toggleProfile;
        consumeEvent(event);
        this.toggle.emit();
    }
}
